module.exports = __webpack_public_path__ + "h5/img/logo2.865b1b7f.png";